/**
 * "Subscribe to calendar" dropdown — details/summary so it works without JS.
 * Scoped: the Google / Apple(webcal) / .ics links carry the currently-active
 * filters (?area=&category=&cost=&when=&time=) so a subscriber gets ONLY their
 * filtered slice, not all events. No filters → the full (90-day-capped) feed.
 */
export interface SubscribeScope {
  area?: string; // csv
  category?: string; // csv
  cost?: string; // 'free' | 'paid'
  when?: string; // preset
  time?: string; // morning | afternoon | evening
}

function buildQuery(scope?: SubscribeScope): string {
  if (!scope) return '';
  const p = new URLSearchParams();
  if (scope.area) p.set('area', scope.area);
  if (scope.category) p.set('category', scope.category);
  if (scope.cost) p.set('cost', scope.cost);
  if (scope.when) p.set('when', scope.when);
  if (scope.time) p.set('time', scope.time);
  const s = p.toString();
  return s ? `?${s}` : '';
}

export function SubscribeMenu({ host, scope }: { host: string; scope?: SubscribeScope }) {
  const query = buildQuery(scope);
  const icsPath = `/calendar.ics${query}`;
  const webcal = `webcal://${host}/calendar.ics${query}`;
  const google = `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(webcal)}`;
  const scoped = query.length > 0;

  return (
    <details className="dropdown">
      <summary className="ui-btn btn-secondary btn-sm">
        <svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true">
          <rect
            x="1.5"
            y="2.5"
            width="13"
            height="12"
            rx="2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path d="M1.5 6h13" stroke="currentColor" strokeWidth="1.5" />
          <path d="M5 1v3M11 1v3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        Subscribe
        <svg width="10" height="7" viewBox="0 0 12 8" aria-hidden="true">
          <path
            d="M1 1l5 5 5-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </summary>
      <div className="dropdown-menu">
        <p className="menu-note">
          Auto-adds new {scoped ? 'matching ' : ''}events to your calendar.
        </p>
        <a href={google} target="_blank" rel="noopener noreferrer">
          Google Calendar
        </a>
        <a href={webcal}>Apple Calendar / Outlook</a>
        <a href={icsPath} download>
          Download .ics file
        </a>
      </div>
    </details>
  );
}
